export const FileManagerEndpoints = {
    uploadImage: '/file-manager/upload/image',
    uploadFile: '/file-manager/upload/file',
    list: '/file-manager/list',
    add: '/file-manager/add',
    edit: (id: string) => `/file-manager/edit/${id}`,
    remove: (id: string) => `/file-manager/del/${id}`,
    info: (id: string) => `/file-manager/${id}`,
}
